/**
 * BUNDLE OFFERS
 *
 * Syncs the selected quantity-break card with the product form it belongs to so
 * the add-to-cart button submits the right variant and quantity.
 *
 * Cards live outside the <form> element, so the form is resolved by id rather
 * than by DOM ancestry. The product section re-renders itself on variant change
 * and in the theme editor, which replaces the markup with a server-rendered
 * copy where only the merchant's default offer is checked, so the shopper's
 * choice is remembered per radio group and restored afterwards.
 */
(function () {
  if (window.bundleOffersInitialized) return;
  window.bundleOffersInitialized = true;

  var HIDDEN_QUANTITY_ATTR = 'data-bundle-offer-quantity';
  var HIDDEN_VARIANT_ATTR = 'data-bundle-offer-variant';
  var selectionByGroup = {};
  var syncScheduled = false;

  function getForm(input) {
    var formId = input.getAttribute('data-form-id');
    return (formId && document.getElementById(formId)) || input.closest('form');
  }

  /**
   * Reuses a quantity field the theme already rendered (the quantity selector
   * block) when present, so the two controls never disagree. Otherwise a hidden
   * field owned by this component is created.
   */
  function setQuantity(form, formId, quantity) {
    var existing = form.querySelector('input[name="quantity"]:not([' + HIDDEN_QUANTITY_ATTR + '])');

    if (!existing && formId) {
      existing = document.querySelector(
        'input[name="quantity"][form="' + formId + '"]:not([' + HIDDEN_QUANTITY_ATTR + '])'
      );
    }

    if (existing) {
      if (existing.value !== String(quantity)) {
        existing.value = quantity;
        existing.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    var hidden = form.querySelector('input[' + HIDDEN_QUANTITY_ATTR + ']');

    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'quantity';
      hidden.setAttribute(HIDDEN_QUANTITY_ATTR, '');
      form.appendChild(hidden);
    }

    hidden.value = quantity;
  }

  function setVariant(form, variantId) {
    if (!variantId) return;

    var input = form.querySelector('input[name="id"], select[name="id"]');

    if (input) {
      // The theme disables this field when a variant picker owns the selection.
      input.disabled = false;
      input.value = variantId;
      return;
    }

    var hidden = form.querySelector('input[' + HIDDEN_VARIANT_ATTR + ']');

    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'id';
      hidden.setAttribute(HIDDEN_VARIANT_ATTR, '');
      form.appendChild(hidden);
    }

    hidden.value = variantId;
  }

  function apply(input) {
    if (!input || input.disabled) return;

    var form = getForm(input);
    if (!form) return;

    var quantity = parseInt(input.getAttribute('data-quantity'), 10);
    if (!(quantity > 0)) quantity = 1;

    var variantId = input.getAttribute('data-variant-id') || null;

    setQuantity(form, input.getAttribute('data-form-id'), quantity);
    setVariant(form, variantId);

    input.dispatchEvent(
      new CustomEvent('bundle-offer:selected', {
        bubbles: true,
        detail: { quantity: quantity, variantId: variantId, form: form },
      })
    );
  }

  /**
   * A block id is stable across re-renders while the DOM node is not, so the
   * remembered choice survives the section being replaced.
   */
  function remember(input) {
    if (input && input.name) selectionByGroup[input.name] = input.value;
  }

  function restore(group) {
    // In the theme editor the merchant's default must win, otherwise changing
    // which offer is preselected appears to do nothing.
    if (window.Shopify && window.Shopify.designMode) return null;

    var remembered = selectionByGroup[group[0].name];
    if (!remembered) return null;

    for (var i = 0; i < group.length; i++) {
      if (group[i].value === remembered && !group[i].disabled) {
        group[i].checked = true;
        return group[i];
      }
    }

    return null;
  }

  function activeInput(group) {
    for (var i = 0; i < group.length; i++) {
      if (group[i].checked && !group[i].disabled) return group[i];
    }

    for (var j = 0; j < group.length; j++) {
      if (!group[j].disabled) return group[j];
    }

    return null;
  }

  function sync() {
    syncScheduled = false;

    var groups = {};

    document.querySelectorAll('input[data-bundle-offer]').forEach(function (input) {
      (groups[input.name] = groups[input.name] || []).push(input);
    });

    Object.keys(groups).forEach(function (name) {
      var group = groups[name];
      var input = restore(group) || activeInput(group);

      if (!input) return;

      input.checked = true;
      remember(input);
      apply(input);
    });
  }

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    requestAnimationFrame(sync);
  }

  document.addEventListener('change', function (event) {
    var input = event.target;

    if (input instanceof HTMLElement && input.matches('input[data-bundle-offer]')) {
      remember(input);
      apply(input);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;

      for (var j = 0; j < added.length; j++) {
        var node = added[j];

        if (node.nodeType !== 1) continue;

        if (node.matches('input[data-bundle-offer]') || node.querySelector('input[data-bundle-offer]')) {
          scheduleSync();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
